unit Main_View;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.WebCtrls, WEBLib.ExtCtrls, WEBLib.REST, Data.DB, WEBLib.CDS;

type
  TMainView = class(TForm)
    revenuechart: THTMLDiv;
    sparkline2: THTMLDiv;
    sparkline1: THTMLDiv;
    sparkline3: THTMLDiv;
    worldmap: THTMLDiv;
    divHTMLTable: THTMLDiv;
    idCallTable: TLinkLabel;
    Datas_Con: TClientConnection;
    execAPIs: THttpRequest;
    Datas_DSET: TClientDataSet;
    DashINV_IdDi: TIntegerField;
    DashINV_DataInv: TDateTimeField;
    DashINV_SItens: TIntegerField;
    DashINV_SRuptura: TIntegerField;
    WebHTMLDashINV: THTMLDiv;
    WebHTMLDashACUR: THTMLDiv;
    WebHTMLDashRUP: THTMLDiv;
    iduser: THTMLSpan;
    chartContainer: THTMLDiv;
    procedure sparkline2MouseEnter(Sender: TObject);
    procedure idCallTableClick(Sender: TObject);
    procedure Datas_ConAfterConnect(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    procedure LoadTable_DataINV;
  protected procedure LoadDFMValues; override; end;

var
  MainView: TMainView;

implementation

{$R *.dfm}

uses
  Login_View;


procedure TMainView.LoadTable_DataINV;
var
  pRUP: real;
  i, cItens, okItens: integer;
  xHeader, xItens: string;
begin

    //Espera em JavasCript
    //asm await sleep(100); end;

    xHeader:=   //Header de Table
    '<table id="Table">'+
        '<thead>'+
            '<tr>'+
                '<th>#</th>'+
                '<th>Data inventário</th>'+
                '<th>Nº Itens</th>'+
                '<th>Nº Ajustes</th>'+
                '<th>Ações</th>'+
            '</tr>'+
        '</thead>'+
      '<tbody>';


    cItens:= 0;
    xItens:= '';
    repeat
        //Cards
        xItens:= xItens +
        '<tr>'+
          '<td data-name="Nº Leitura" id="iddi' + IntToStr(cItens) + '" value="' + Datas_DSET.FieldByName('iddi').AsString + '">' + Datas_DSET.FieldByName('iddi').AsString + '</td>'+
          '<td data-name="DataInv" id="DataInv' + IntToStr(cItens) + '">' + FormatDateTime('dd/mm/yyyy', Datas_DSET.FieldByName('DataInv').AsDateTime) + '</td>'+
          '<td data-name="SItens" id="SItens' + IntToStr(cItens) + '">' + Datas_DSET.FieldByName('SItens').AsString + '</td>'+
          '<td data-name="SRuptura" id="SRuptura' + IntToStr(cItens) + '">' + Datas_DSET.FieldByName('SRuptura').AsString + '</td>'+


					'<td><button type="button" class="btn btn-warning custom-sm bi bi-pencil-square" id="edit' + IntToStr(cItens) + '" ></button>'+
					'<button type="button" class="btn btn-danger custom-sm bi bi-trash" id="zap' + IntToStr(cItens) + '" style="margin-left: 1px;"></button>'+ '</td>'+

          //Botoes anteriores MAIS BONITOS, acima como NÂO foi disativado s botões então colocar os "bi bi-pencil-square"
					//'<td><button type="button" class="btn btn-warning btn-sm" id="edit' + IntToStr(cItens) + '" ><i class="fa fa-edit"></i></button>'+
					//'<button type="button" class="btn btn-danger btn-sm" id="zap' + IntToStr(cItens) + '" style="margin-left: 1px;"><i class="fa fa-trash"></i></button>'+ '</td>'+
          //'<td><button type="button" class="btn btn-warning btn-sm" id="edit" onclick="myBtnClick()" onclick="javascript:alert(' + #39 + 'Número do Identificador: ' + Datas_DSET.FieldByName('idudv').AsString + #39 + ')"><i class="fa fa-edit"></i></button>'+

					//'<button type="button" class="btn btn-danger btn-xs" id="delete"><i class="fa fa-trash" onclick="Act_delete(xxx)"></i></button></td>'+

        '</tr>';

        //Por enquanto o primeiro registro
        if cItens = 0 then
        begin

          //A- Limpa Dashsboards
          WebHTMLDashINV.HTML.Clear;
          WebHTMLDashACUR.HTML.Clear;
          WebHTMLDashRUP.HTML.Clear;

          //B- Transfere Dados para os DashBoards
          //Total Itens inventariados
          WebHTMLDashINV.HTML.Add('<h3>' + Datas_DSET.FieldByName('SItens').AsString + '</h3><p>Itens inventariados</p>');

          //Cálculo do percentual da Ruptura
          pRUP:= 0;
          if Datas_DSET.FieldByName('SItens').AsFloat > 0 then
          begin
              pRUP:= Datas_DSET.FieldByName('SRuptura').AsFloat / Datas_DSET.FieldByName('SItens').AsFloat
          end;
          okItens:=  Datas_DSET.FieldByName('SItens').AsInteger - Datas_DSET.FieldByName('SRuptura').AsInteger;

          //Percentual de Acurácia (1- Ruptura) * 100
          WebHTMLDashACUR.HTML.Add('<h3>' + FormatFloat('0.0', (1 - pRUP)*100) + '<sup class="fs-5">% ' + IntToStr(okItens) + ' itens</sup></h3><p>Acurácia de estoque</p>');

          //Percentual de Acurácia (Ruptura) * 100
          WebHTMLDashRUP.HTML.Add('<h3>' + FormatFloat('0.0', (pRUP)*100) + '<sup class="fs-5">% ' + Datas_DSET.FieldByName('SRuptura').AsString + ' itens</sup></h3><p>Ruptura de estoque</p>');

        end;

        inc(cItens); //Incrementa Itens para poder variar o código de barras

        //Vefifica se é 0 começo da linha (8 mod 4 = 0), verificar no último campo
        // Não precisa da instrução { and (cItens <> 0 )} pois somou acima
        {if cItens MOD qCards = 0 then
        begin
           vItens:= vItens + '</div>';
        end;}

        Datas_DSET.Next;

    until(Datas_DSET.Eof);

    //Transfere Dados para Div "Table"
    divHTMLTable.HTML.Clear;
    divHTMLTable.HTML.Add(xHeader + xItens + '</tbody>');

    chartContainer.HTML.Clear;
    //chartContainer.HTML.Add(xHeader + xItens + '</tbody>');


end;

procedure TMainView.Datas_ConAfterConnect(Sender: TObject);
begin
    LoadTable_DataINV;  //Ler a Tabela primeiramente
end;

procedure TMainView.idCallTableClick(Sender: TObject);
var
  xURL, Criterio: string;
begin
//https://dev.to/madsstoumann/charts-in-css-1di1

//B- Pesquisa as Datas


      xURL:= '';
      Criterio:= '';

      try
        Datas_Con.Active:= false;

        //http://localhost:8082/api/inventario/datas?offset=0&fetch=4
        xURL := LoginView.BaseURL + 'inventario/dashboard?offset=0&fetch=6';
        //http://localhost:8083/api/carga?offset=0&fetch=10&iduser=47&qtdesaldo%3E0

        //MousePointer.Cursor := -11;
        if Criterio = '' then
        begin
          //UTF8Encode(BaseURL);
          Datas_Con.URI := xURL;
        end else begin

          //Datas_Con.URI := BaseURL+'&'+xCampo+'='+Interm;
          Datas_Con.URI := xURL;
          // ' = %27
          // % = %25;
          // % = &#37;
          //produtos?offset=0&fetch=100&gestao=0
        end;
        Datas_Con.Active:= true;
      finally
        //Screen.Cursor := 0;
      end;
//B- Pesquisa as Datas
end;

procedure TMainView.sparkline2MouseEnter(Sender: TObject);
begin
    ShowMessage('Buscar dados de Sub Lotes !');
end;

procedure TMainView.WebFormShow(Sender: TObject);
begin
    //Busca Nome do Usuário
    iduser.HTML.Clear;
    iduser.HTML.Add(LoginView.EditEmail.Text);
end;

procedure TMainView.LoadDFMValues;
begin
  inherited LoadDFMValues;

  idCallTable := TLinkLabel.Create('idCallTable');
  revenuechart := THTMLDiv.Create('revenue-chart');
  sparkline2 := THTMLDiv.Create('sparkline-2');
  sparkline1 := THTMLDiv.Create('sparkline-1');
  sparkline3 := THTMLDiv.Create('sparkline-3');
  worldmap := THTMLDiv.Create('world-map');
  divHTMLTable := THTMLDiv.Create('Table');
  WebHTMLDashINV := THTMLDiv.Create('DashINV');
  WebHTMLDashACUR := THTMLDiv.Create('DashACUR');
  WebHTMLDashRUP := THTMLDiv.Create('DashRUP');
  iduser := THTMLSpan.Create('iduser');
  chartContainer := THTMLDiv.Create('chartContainer');
  Datas_Con := TClientConnection.Create(Self);
  execAPIs := THttpRequest.Create(Self);
  Datas_DSET := TClientDataSet.Create(Self);
  DashINV_IdDi := TIntegerField.Create(Self);
  DashINV_DataInv := TDateTimeField.Create(Self);
  DashINV_SItens := TIntegerField.Create(Self);
  DashINV_SRuptura := TIntegerField.Create(Self);

  idCallTable.BeforeLoadDFMValues;
  revenuechart.BeforeLoadDFMValues;
  sparkline2.BeforeLoadDFMValues;
  sparkline1.BeforeLoadDFMValues;
  sparkline3.BeforeLoadDFMValues;
  worldmap.BeforeLoadDFMValues;
  divHTMLTable.BeforeLoadDFMValues;
  WebHTMLDashINV.BeforeLoadDFMValues;
  WebHTMLDashACUR.BeforeLoadDFMValues;
  WebHTMLDashRUP.BeforeLoadDFMValues;
  iduser.BeforeLoadDFMValues;
  chartContainer.BeforeLoadDFMValues;
  Datas_Con.BeforeLoadDFMValues;
  execAPIs.BeforeLoadDFMValues;
  Datas_DSET.BeforeLoadDFMValues;
  DashINV_IdDi.BeforeLoadDFMValues;
  DashINV_DataInv.BeforeLoadDFMValues;
  DashINV_SItens.BeforeLoadDFMValues;
  DashINV_SRuptura.BeforeLoadDFMValues;
  try
    Name := 'MainView';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    idCallTable.SetParentComponent(Self);
    idCallTable.Name := 'idCallTable';
    idCallTable.Left := 141;
    idCallTable.Top := 175;
    idCallTable.Width := 57;
    idCallTable.Height := 15;
    idCallTable.ElementFont := efCSS;
    idCallTable.HeightStyle := ssAuto;
    idCallTable.WidthStyle := ssAuto;
    idCallTable.HeightPercent := 100.000000000000000000;
    idCallTable.WidthPercent := 100.000000000000000000;
    SetEvent(idCallTable, Self, 'OnClick', 'idCallTableClick');
    idCallTable.Caption := 'idCallTable';
    revenuechart.SetParentComponent(Self);
    revenuechart.Name := 'revenuechart';
    revenuechart.Left := 8;
    revenuechart.Top := 48;
    revenuechart.Width := 96;
    revenuechart.Height := 25;
    revenuechart.HeightStyle := ssAuto;
    revenuechart.WidthStyle := ssAuto;
    revenuechart.ElementPosition := epIgnore;
    revenuechart.ElementFont := efCSS;
    revenuechart.Role := '';
    sparkline2.SetParentComponent(Self);
    sparkline2.Name := 'sparkline2';
    sparkline2.Left := 8;
    sparkline2.Top := 206;
    sparkline2.Width := 96;
    sparkline2.Height := 25;
    sparkline2.HeightStyle := ssAuto;
    sparkline2.WidthStyle := ssAuto;
    sparkline2.ChildOrder := 1;
    sparkline2.ElementPosition := epIgnore;
    sparkline2.ElementFont := efCSS;
    sparkline2.Role := '';
    SetEvent(sparkline2, Self, 'OnMouseEnter', 'sparkline2MouseEnter');
    sparkline1.SetParentComponent(Self);
    sparkline1.Name := 'sparkline1';
    sparkline1.Left := 8;
    sparkline1.Top := 175;
    sparkline1.Width := 96;
    sparkline1.Height := 25;
    sparkline1.HeightStyle := ssAuto;
    sparkline1.WidthStyle := ssAuto;
    sparkline1.ChildOrder := 2;
    sparkline1.ElementPosition := epIgnore;
    sparkline1.ElementFont := efCSS;
    sparkline1.Role := '';
    sparkline3.SetParentComponent(Self);
    sparkline3.Name := 'sparkline3';
    sparkline3.Left := 8;
    sparkline3.Top := 237;
    sparkline3.Width := 96;
    sparkline3.Height := 25;
    sparkline3.HeightStyle := ssAuto;
    sparkline3.WidthStyle := ssAuto;
    sparkline3.ChildOrder := 3;
    sparkline3.ElementPosition := epIgnore;
    sparkline3.ElementFont := efCSS;
    sparkline3.Role := '';
    worldmap.SetParentComponent(Self);
    worldmap.Name := 'worldmap';
    worldmap.Left := 8;
    worldmap.Top := 95;
    worldmap.Width := 96;
    worldmap.Height := 25;
    worldmap.HeightStyle := ssAuto;
    worldmap.WidthStyle := ssAuto;
    worldmap.ChildOrder := 4;
    worldmap.ElementPosition := epIgnore;
    worldmap.ElementFont := efCSS;
    worldmap.Role := '';
    divHTMLTable.SetParentComponent(Self);
    divHTMLTable.Name := 'divHTMLTable';
    divHTMLTable.Left := 141;
    divHTMLTable.Top := 101;
    divHTMLTable.Width := 188;
    divHTMLTable.Height := 25;
    divHTMLTable.HeightStyle := ssAuto;
    divHTMLTable.WidthStyle := ssAuto;
    divHTMLTable.ChildOrder := 5;
    divHTMLTable.ElementPosition := epIgnore;
    divHTMLTable.ElementFont := efCSS;
    divHTMLTable.Role := '';
    WebHTMLDashINV.SetParentComponent(Self);
    WebHTMLDashINV.Name := 'WebHTMLDashINV';
    WebHTMLDashINV.Left := 141;
    WebHTMLDashINV.Top := 8;
    WebHTMLDashINV.Width := 188;
    WebHTMLDashINV.Height := 25;
    WebHTMLDashINV.HeightStyle := ssAuto;
    WebHTMLDashINV.WidthStyle := ssAuto;
    WebHTMLDashINV.ChildOrder := 5;
    WebHTMLDashINV.ElementPosition := epIgnore;
    WebHTMLDashINV.ElementFont := efCSS;
    WebHTMLDashINV.Role := '';
    WebHTMLDashACUR.SetParentComponent(Self);
    WebHTMLDashACUR.Name := 'WebHTMLDashACUR';
    WebHTMLDashACUR.Left := 141;
    WebHTMLDashACUR.Top := 39;
    WebHTMLDashACUR.Width := 188;
    WebHTMLDashACUR.Height := 25;
    WebHTMLDashACUR.HeightStyle := ssAuto;
    WebHTMLDashACUR.WidthStyle := ssAuto;
    WebHTMLDashACUR.ChildOrder := 5;
    WebHTMLDashACUR.ElementPosition := epIgnore;
    WebHTMLDashACUR.ElementFont := efCSS;
    WebHTMLDashACUR.Role := '';
    WebHTMLDashRUP.SetParentComponent(Self);
    WebHTMLDashRUP.Name := 'WebHTMLDashRUP';
    WebHTMLDashRUP.Left := 141;
    WebHTMLDashRUP.Top := 70;
    WebHTMLDashRUP.Width := 188;
    WebHTMLDashRUP.Height := 25;
    WebHTMLDashRUP.HeightStyle := ssAuto;
    WebHTMLDashRUP.WidthStyle := ssAuto;
    WebHTMLDashRUP.ChildOrder := 5;
    WebHTMLDashRUP.ElementPosition := epIgnore;
    WebHTMLDashRUP.ElementFont := efCSS;
    WebHTMLDashRUP.Role := '';
    iduser.SetParentComponent(Self);
    iduser.Name := 'iduser';
    iduser.Left := 141;
    iduser.Top := 132;
    iduser.Width := 96;
    iduser.Height := 25;
    iduser.HeightStyle := ssAuto;
    iduser.WidthStyle := ssAuto;
    iduser.ChildOrder := 13;
    iduser.ElementPosition := epIgnore;
    iduser.ElementFont := efCSS;
    iduser.Role := '';
    chartContainer.SetParentComponent(Self);
    chartContainer.Name := 'chartContainer';
    chartContainer.Left := 141;
    chartContainer.Top := 237;
    chartContainer.Width := 96;
    chartContainer.Height := 25;
    chartContainer.HeightStyle := ssAuto;
    chartContainer.WidthStyle := ssAuto;
    chartContainer.ChildOrder := 11;
    chartContainer.ElementPosition := epIgnore;
    chartContainer.ElementFont := efCSS;
    chartContainer.Role := '';
    Datas_Con.SetParentComponent(Self);
    Datas_Con.Name := 'Datas_Con';
    Datas_Con.Active := False;
    Datas_Con.DataNode := 'data';
    Datas_Con.Delimiter := ';';
    Datas_Con.AfterConnect := Datas_ConAfterConnect;
    Datas_Con.Left := 376;
    Datas_Con.Top := 16;
    execAPIs.SetParentComponent(Self);
    execAPIs.Name := 'execAPIs';
    execAPIs.Left := 379;
    execAPIs.Top := 129;
    Datas_DSET.SetParentComponent(Self);
    Datas_DSET.Name := 'Datas_DSET';
    Datas_DSET.Connection := Datas_Con;
    Datas_DSET.Left := 376;
    Datas_DSET.Top := 72;
    DashINV_IdDi.SetParentComponent(Datas_DSET);
    DashINV_IdDi.Name := 'DashINV_IdDi';
    DashINV_IdDi.FieldName := 'iddi';
    DashINV_DataInv.SetParentComponent(Datas_DSET);
    DashINV_DataInv.Name := 'DashINV_DataInv';
    DashINV_DataInv.FieldName := 'datainv';
    DashINV_SItens.SetParentComponent(Datas_DSET);
    DashINV_SItens.Name := 'DashINV_SItens';
    DashINV_SItens.FieldName := 'sitens';
    DashINV_SRuptura.SetParentComponent(Datas_DSET);
    DashINV_SRuptura.Name := 'DashINV_SRuptura';
    DashINV_SRuptura.FieldName := 'sruptura';
  finally
    idCallTable.AfterLoadDFMValues;
    revenuechart.AfterLoadDFMValues;
    sparkline2.AfterLoadDFMValues;
    sparkline1.AfterLoadDFMValues;
    sparkline3.AfterLoadDFMValues;
    worldmap.AfterLoadDFMValues;
    divHTMLTable.AfterLoadDFMValues;
    WebHTMLDashINV.AfterLoadDFMValues;
    WebHTMLDashACUR.AfterLoadDFMValues;
    WebHTMLDashRUP.AfterLoadDFMValues;
    iduser.AfterLoadDFMValues;
    chartContainer.AfterLoadDFMValues;
    Datas_Con.AfterLoadDFMValues;
    execAPIs.AfterLoadDFMValues;
    Datas_DSET.AfterLoadDFMValues;
    DashINV_IdDi.AfterLoadDFMValues;
    DashINV_DataInv.AfterLoadDFMValues;
    DashINV_SItens.AfterLoadDFMValues;
    DashINV_SRuptura.AfterLoadDFMValues;
  end;
end;

end.
